const Constants = {
  routes: {
    root: '/gip',
    menu: '/gip/menu',
    gip: '/gip/details',
    bpsMarket: '/gip/bps/market',
    rankings: '/gip/rankings',
    rankingsMap: '/gip/rankings/map',
    rankingsCountry: '/gip/rankings/map/:countryCode',
    rankingsCountryGraphics: '/gip/rankings/map/:countryCode/graphics',
    rankingsTiers: '/gip/rankings/:yearCode/tiers',
    rankingsTierGraphics: '/gip/rankings/:yearCode/tiers/:tierCode',
    economicResearch: '/gip/economic-research',
    gipDownload: '/gip/economic-research-gip-download',
    error: '/gip/error',
    bps: '/gip/bps',
    bpsRegions: '/gip/bps/economic-regions',
    bpsProportion: '/gip/bps/markets-proportion',
  },
  values: {
    headerHeight: '5vh',
    sidebarHeight: '95vh',
    contentHeight: '95vh'
  }
};

export default Constants;
